<div class="page-header-container">
  <ng-content select="[page-title]"></ng-content>
  <span class="spacer"></span>
  <ng-content select="[action-type=button]"></ng-content>
</div>
